export default "__VITE_ASSET__CF93mD0a__"